/**
 * Domain utilities for multi-domain support.
 * Used to detect the current domain and resolve domain-specific configuration.
 */

export const getCurrentHostname = (): string => {
  return window.location.hostname;
};

export const isAlternateDomain = (): boolean => {
  return ['lifyclubfx.com', 'localhost'].includes(getCurrentHostname());
};

export const getSiteDomain = (): string => {
  const hostname = getCurrentHostname();
  if (['lifyclubfx.com', 'localhost'].includes(hostname)) {
    return 'lifyclubfx.com';
  }
  // Lovable preview/published domains — return as-is for testing
  if (hostname.endsWith('.lovable.app')) {
    return hostname;
  }
  return 'theclub.finance';
};
